const project = [
    {
        id: 1,
        title: "Covid Tracker",
        url : "https://drive.google.com/uc?id=1kEP3wjviR_Ccm73P62sbS0h-xgWIhobR",
        info : "A react project using Covid tracker api and async await fetch to show table record of covid-19 in India."
    },
    {
        id: 2,
        title: "Pokemon Wall",
        url : "https://drive.google.com/uc?id=1nYnlwdB2VgVIJMZRSe-F5gq_7t7IBDrF",
        info : "A react project using axios and pokeapi to fetch images of pokemons and their respective names"
    },
    {
        id: 3,
        title: "Notes Keeper",
        url : "https://drive.google.com/uc?id=19MEi2I3UNKUWvQoUCPltcfhoXSUhp6lH",
        info : "A react app which can store notes you write but only until we refresh the page as it does not have capablity to store data."
    },
    {
        id: 4,
        title: "Simon Game",
        url : "https://drive.google.com/uc?id=1Tozr5eUy9IlbTb5-t6Ge8Tdr_KRoRjSw",
        info : "A unique and interesting Game (Simon Game)"
    },
    {
        id: 5,
        title: "The Drum Kit",
        url : "https://drive.google.com/uc?id=1w6HU9g_AfQo3lcqRSADq-n-MY9scpm9o",
        info : "A drum kit setup made using HTML , CSS & Javascript. On pressing the desired keys plays the audio associated with it as in a drum."
    },
    {
        id: 6,
        title: "Husky",
        url : "https://drive.google.com/uc?id=1WekqNx0PplyPJ16HAIrHh2SqhfswXUun",
        info : "Complete Responsive Husky Web Page build using HTML , CSS & Bootstrap."
    },
    {
        id: 7,
        title: "Movies App",
        url : "https://drive.google.com/uc?id=1_HtySpbEa1ghF59BTcxAEoaS64ZpSxGf",
        info : "A react app displaying movies name and poster from a local self made api"
    }
];
export default project;